import React, { useEffect } from 'react';
import { Container, Typography, Paper, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const LegalPageLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth="md" style={{ padding: '30px 20px' }}>
      <Paper style={{ padding: '30px', lineHeight: 1.7 }}>
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>

        {updated && (
          <Typography
            variant="body2"
            color="textSecondary"
            gutterBottom
            style={{ marginBottom: '25px' }}
          >
            Last updated: {updated}
          </Typography>
        )}

        {children}

        <Box style={{ marginTop: '30px' }}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
          >
            Back to Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default LegalPageLayout;